import { useEffect } from 'react';
import { useShareTokenContext } from '../contexts/ShareTokenContext';
import { setReferralCode } from '../utils/referralStorage';

export const useReferralCapture = (): void => {
  const { payload } = useShareTokenContext();
  const ref = payload?.ref;
  useEffect(() => {
    if (ref !== undefined) {
      setReferralCode(ref);
    }
  }, [ref]);
};
